import { DynamicHelmet } from "@interfaces/misc"
import CommonRepo from "@lib/api/server-side/common.repo"
import { HomePage } from "@modules/homepage/Homepage"
import { GetServerSideProps } from "next"

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const common = new CommonRepo()

  try {
    const res = await common.getMetaTag("non-prakerja")
    let meta: DynamicHelmet | null = null

    if (res.statusCode === 200) {
      const result = JSON.parse(res.body).result

      if (result) {
        meta = {
          title: result.meta_title,
          description: result.meta_description,
        }
      }
    }

    return {
      props: {
        meta,
      },
    }
  } catch (e) {
    console.log(e)

    return {
      props: {
        meta: null,
      },
    }
  }
}

export default HomePage
